export const EnumConfiguracion = {
  Intentos_Sesion: "IS001",
  Tiempo_Sesion_Bloqueada: "TSB001",
  Tiempo_Codigo_Autenticacion: "TCA001",
  Tiempo_Codigo_Recuperar_Contrasena: "TCRC001",
  Contrasenia_Longitud_Minima: "CLM001",
  Contrasenia_Longitud_Maxima: "CLM002",
  Contrasenia_Requiere_Mayusculas: "CRM001",
  Contrasenia_Requiere_Numeros: "CRN001",
  Contrasenia_Requiere_Caracteres_Especiales: "CRCE001",
  Tiempo_Inactividad: "TI001",
};

export const EnumProfiles = {
  Administrador: 1,
  Empleado: 2,
  Proveedor: 3,
  Consultor: 4,
};

export const EnumStatusCatalogs = {
  Activo: 2,
  Inactivo: 3,
  Eliminado: 4,
};

export const EnumStatusShipment = {
  Creado: 6,
  Recibido: 7,
  Documentado: 8,
  En_Transito: 9,
  Entregado: 10,
};

export const EnumStatusShipmentString = {
  Creado: 'CREADO',
  Recibido: 'RECIBIDO',
  Documentado: 'DOCUMENTADO',
  En_Transito: 'EN TRANSITO',
  Entregado: 'ENTREGADO',
  No_Entregado: 'NO ENTREGADO'
};

export const EnumStatusEmbarque = {
  Creado: 12,
  En_Transito: 13,
  Entregado: 14,
  No_Entregado: 15
}

export const EnumStatusEmbarqueString = {
  Creado: 'CREADO',
  En_Transito: 'EN TRANSITO',
  Entregado: 'ENTREGADO',
  No_Entregado: 'NO ENTREGADO'
}

export const EnumCatalogosEncabezado = {
  Estatus: 'Estatus',
  EstatusEnvios: 'Estatus Envios',
  EstatusEmbarque: 'Estatus Embarque'
}

export const EnumPerfiles = {
  Administrador: "ADMINISTRADOR",
  Empleado: "EMPLEADO",
  Proveedor: "PROVEEDOR",
  Consultor: "CONSULTOR",
}

export const EnumCatalogoEstatusString = {
  Activo: 'ACTIVO',
  Inactivo: 'INACTIVO',
  Eliminado: 'ELIMINADO'
}
